export enum TapesLabels {
  dimensions = "dimensions",
  material = "material",
  print = "print",
}
